import { env } from '@/env';

import { gtmInterface, type ITagManager } from './gtmInterface';
import { gtmMockInterface } from './gtmMockInterface';

const getGTM = env.VITE_IS_GA_ENABLED && !env.VITE_LOCALHOST ? gtmInterface() : gtmMockInterface();

type Promisified<T> = {
    [K in keyof T]: T[K] extends (...args: any) => infer R ? (...args: Parameters<T[K]>) => Promise<R> : T;
};

export const TagManager: Promisified<ITagManager> = {
    initialize: async (...options) => {
        const gtm = await getGTM;

        gtm.initialize(...options);
    },
    push: async (...options) => {
        const gtm = await getGTM;

        gtm.push(...options);
    },
};
